'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actions = exports.types = undefined;

var _ActionCreatorHelper = require('./ActionCreatorHelper');

var _proptypes = require('proptypes');

var _proptypes2 = _interopRequireDefault(_proptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _actions = [{
    type: 'INIT_HISTORY',
    propTypes: {
        useBrowserHistory: _proptypes2.default.bool,
        initialState: _proptypes2.default.object
    }
}, {
    type: 'PUSH_STATE',
    propTypes: {
        state: _proptypes2.default.object
    }
}, {
    type: 'STATE_UPDATE',
    propTypes: {
        state: _proptypes2.default.object
    }
}, {
    type: 'GO',
    propTypes: {
        position: _proptypes2.default.number
    }
}, {
    type: 'GO_BACK',
    propTypes: {}
}, {
    type: 'RESET_HISTORY',
    propTypes: {}
}];

var types = exports.types = (0, _ActionCreatorHelper.createTypes)(_actions);
var actions = exports.actions = (0, _ActionCreatorHelper.createActions)(_actions);